// customDatePlugin.js

export const reviewPlugin = {
  name: "reviewPlugin",
  display: "command",
  title: "Insertar Reseña",
  buttonClass: "",
  innerHTML: 'R',
  add: function (core, targetElement) {
    // console.log("Add")

    const context = core.context;
    context.reviewPlugin = {
      targetButton: targetElement,
      open: null,
      activeElement:null
    };

    // context.reviewPlugin = {
    //   targetButton: targetElement,
    // };

    /*
    // const context = core.context;
    const insertText = () => {
      const date = new Date().toLocaleDateString();
      // core.insertText(date);
      // core.insertText(date);
      console.log( core )
      console.log( targetElement )
      console.log( date )

      const editor = core.context.element; // Accede al editor desde el contexto
      console.log(editor); // Esto te dará acceso al editor Suneditor
    
      // Ahora puedes usar el editor según tus necesidades
      // editor.insertHTML('<p>¡Hola, mundo!</p>');       
    };

    context.customDatePlugin_insertDate = insertText;
    targetElement.addEventListener('click', context.customDatePlugin_insertDate);
    */
    /*
    const insertButton = () => {

      console.log( core )
      console.log( targetElement )

      const newNode = document.createElement('button');
      newNode.innerHTML = '¡Este es un nuevo nodo!';
      // newNode.setAttribute("name", value)
      // newNode.setAttribute("name", value)
      // newNode.setAttribute("name", value)
      newNode.dataset.title = "Titulo"
      newNode.dataset.authors = "authors"
      newNode.dataset.content = "content"

      // http://suneditor.com/sample/html/out/document-editor.html
      // Inserta el nodo en el editor
      core.insertNode(newNode);

    };

    const rangeTag = core.util.createElement('div');
    context.customCommand = {
      targetButton: targetElement,
      tag: rangeTag
    };
    // targetElement.addEventListener('click', insertButton);
*/
  },

  active: function (element) {
    if (!element) {
      this.util.removeClass(
        this.context.reviewPlugin.targetButton,
        "active"
      );
    } else if (
      /^mark$/i.test(element.nodeName) &&
      element.style.backgroundColor.length > 0
    ) {
      this.util.addClass(this.context.reviewPlugin.targetButton, "active");
      return true;
    }

    return false;
  },
  action: function () {
    if (
      !this.util.hasClass(this.context.reviewPlugin.targetButton, "active")
    ) {
      const newNode = this.util.createElement("MARK");
      newNode.style.backgroundColor = "hsl(60,75%,60%)";
      this.nodeChange(newNode, ["background-color"], null, null);
    } else {
      this.nodeChange(null, ["background-color"], ["mark"], true);
    }
  },
};
